//InputBar2.vue /* eslint-disable no-undef */
<template>
	<!-- Title -->
	<!-- ------------------------------------------------------------------------------------------------------------- -->
	<div id="title-container">
		<div id="title" @click="$emit('collapseInputBarClicked'), (rotate = !rotate)">User Input</div>
		<input type="checkbox" name="collapse" id="checkbox-collapse-input" class="checkbox-collapse" value="false" @click="$emit('collapseInputBarClicked'), (rotate = !rotate)" />
		<label for="checkbox-collapse-input" class="lbl-checkbox-collapse">
			<div class="display-icon">
				<i id="arrow-input" class="fas fa-chevron-down"></i>
			</div>
		</label>
	</div>

	<div id="bar" v-if="rotate">
		<!-- Placeholder -->
		<!-- ------------------------------------------------------------------------------------------------------------- -->
		<div id="title-placeholder"></div>

		<!-- Material -->
		<!-- ------------------------------------------------------------------------------------------------------------- -->
		<div id="material" v-if="rotate">
			<div class="box">
				<div class="box-title">Material</div>

				<form id="material-form" action="">
					<!-- Steel -->
					<input type="radio" name="Steel" id="1" class="hidebox" value="Steel" checked v-model="material" @change="$emit('updateMaterial', $event.target.value)" />
					<label for="1" class="lbl-radio">
						<div class="display-box">
							<img class="icon" src="imgs/material-icons/steel.svg" />
							<div class="slab-system">Steel</div>
						</div>
					</label>

					<!-- Concrete -->
					<input type="radio" name="Concrete" id="2" class="hidebox" value="Concrete" v-model="material" @change="$emit('updateMaterial', $event.target.value)" />
					<label for="2" class="lbl-radio">
						<div class="display-box">
							<img class="icon" src="imgs/material-icons/concrete.svg" />
							<div class="slab-system">Concrete</div>
						</div>
					</label>

					<!-- Timber -->
					<input type="radio" name="Timber" id="3" class="hidebox" value="Timber" v-model="material" @change="$emit('updateMaterial', $event.target.value)" />
					<label for="3" class="lbl-radio">
						<div class="display-box">
							<img class="icon" src="imgs/material-icons/timber.svg" />
							<div class="slab-system">Timber</div>
						</div>
					</label>

					<!-- Hybrid -->
					<input type="radio" name="Hybrid" id="4" class="hidebox" value="Hybrid" v-model="material" @change="$emit('updateMaterial', $event.target.value)" />
					<label for="4" class="lbl-radio">
						<div class="display-box">
							<img class="icon" src="imgs/material-icons/hybrid.svg" />
							<div class="slab-system">Hybrid</div>
						</div>
					</label>
				</form>
			</div>
		</div>

		<!-- Separating Line -->
		<hr class="separate-line" v-if="rotate" />

		<!-- Geometry -->
		<!-- ------------------------------------------------------------------------------------------------------------- -->
		<div id="geometry" v-if="rotate">
			<div class="box">
				<div class="box-title">Geometry</div>

				<!-- Building Height -->
				<div class="input-field">
					<p class="input-text">Building Height</p>
					<input id="slider-building-height" type="range" class="range-slider" v-model="formattedBuildingHeightValue" min="3.0" max="40.0" step="0.5" @change="$emit('updateBuildingHeight', $event.target.value)" />
					<input id="label-building-height" type="text" class="range-input" v-model="formattedBuildingHeightValue" @change="$emit('updateBuildingHeight', $event.target.value)" />
					<p class="unit">m</p>
				</div>

				<!-- Floor Height -->
				<div class="input-field">
					<p class="input-text">Floor Height</p>
					<input id="slider-floor-height" type="range" class="range-slider" v-model="formattedFloorHeightValue" min="3.0" max="6.0" step="0.1" @change="$emit('updateFloorHeight', $event.target.value)" />
					<input id="label-floor-height" type="text" class="range-input" v-model="formattedFloorHeightValue" @change="$emit('updateFloorHeight', $event.target.value)" />
					<p class="unit">m</p>
				</div>

				<!-- Span in x-Direction -->
				<div class="input-field">
					<p class="input-text">Span in x-Direction</p>
					<input id="slider-xSpan" type="range" class="range-slider" v-model="formattedXSpanValue" min="1.5" max="12.0" step="0.1" @change="$emit('updateXSpanValue', $event.target.value)" />
					<input id="label-xSpan" type="text" class="range-input" v-model="formattedXSpanValue" @change="$emit('updateXSpanValue', $event.target.value)" />
					<p class="unit">m</p>
				</div>

				<!-- Span in y-Direction  -->
				<div class="input-field">
					<p class="input-text">Span in y-Direction</p>
					<input id="slider-ySpan" type="range" class="range-slider" v-model="formattedYSpanValue" min="1.5" max="12.0" step="0.1" @change="$emit('updateYSpanValue', $event.target.value)" />
					<input id="label-ySpan" type="text" class="range-input" v-model="formattedYSpanValue" @change="$emit('updateYSpanValue', $event.target.value)" />
					<p class="unit">m</p>
				</div>
			</div>
		</div>

		<!-- Separating Line -->
		<hr class="separate-line" v-if="rotate" />

		<!-- Structural -->
		<!-- ------------------------------------------------------------------------------------------------------------- -->
		<div id="structural" v-if="rotate">
			<div class="box">
				<div class="box-title">Structural</div>

				<!-- Slab System -->
				<div class="input-field">
					<p class="input-text">Slab System</p>

					<input class="radio-button-system" type="radio" id="plate" name="system" value="Plate" checked v-model="structuralSystem" @change="$emit('updateStructuralSystem', $event.target.value)" />
					<label class="radio-button-system-label" for="plate">
						<p class="system-text">
							<!-- Plate -->
							{{ plateSystem }}
						</p>
					</label>

					<input class="radio-button-system" type="radio" id="beam" name="system" value="Beam" v-model="structuralSystem" @change="$emit('updateStructuralSystem', $event.target.value)" />
					<label class="radio-button-system-label" for="beam">
						<p class="system-text">
							<!-- Beam -->
							{{ beamSystem }}
						</p>
					</label>
				</div>

				<!-- Live Load -->
				<div class="input-field">
					<p class="input-text">Live Load (char.)</p>
					<input id="slider-live-load" type="range" class="range-slider" v-model="formattedLiveLoadValue" min="1.0" max="5.0" step="0.05" @change="$emit('updateLiveLoadValue', $event.target.value)" />
					<input id="label-live-load" type="text" class="range-input" v-model="formattedLiveLoadValue" @change="$emit('updateLiveLoadValue', $event.target.value)" />
					<p class="unit">kN/m&sup2;</p>
				</div>

				<!-- Dead Load -->
				<div class="input-field">
					<p class="input-text">Dead Load (char.)</p>
					<input id="slider-dead-load" type="range" class="range-slider" v-model="formattedDeadLoadValue" min="1.0" max="3.0" step="0.05" @change="$emit('updateDeadLoadValue', $event.target.value)" />
					<input id="label-dead-load" type="text" class="range-input" v-model="formattedDeadLoadValue" @change="$emit('updateDeadLoadValue', $event.target.value)" />
					<p class="unit">kN/m&sup2;</p>
				</div>

				<!-- Beam Distance -->
				<div class="input-field" v-if="material == 'Steel' || (material == 'Hybrid' && structuralSystem == 'Beam')">
					<p class="input-text">Beam Distance</p>
					<input id="slider-beam-dist" type="range" class="range-slider" v-model="formattedBeamDistValue" min="0.5" max="8.5" step="0.1" @change="$emit('updateBeamDistValue', $event.target.value)" />
					<input id="label-beam-dist" type="text" class="range-input" v-model="formattedBeamDistValue" @change="$emit('updateBeamDistValue', $event.target.value)" />
					<p class="unit">m</p>
				</div>
			</div>
		</div>

		<!-- Separating Line -->
		<hr class="separate-line" v-if="rotate" />

		<!-- Carbon -->
		<!-- ------------------------------------------------------------------------------------------------------------- -->
		<div id="carbon" v-if="rotate">
			<div class="box">
				<div class="box-title">Carbon</div>

				<!-- ECF Database -->
				<div class="input-field">
					<p class="input-text">ECF Database</p>

					<input class="radio-button-database" type="radio" id="ice" name="ecf-database" value="ICE" v-model="ecfDatabase" @change="ecfDatabaseChange" checked />
					<label class="radio-button-database-label" for="ice">
						<p class="database-text">ICE</p>
					</label>

					<input class="radio-button-database" type="radio" id="oekobaudat" name="ecf-database" value="Oekobaudat" v-model="ecfDatabase" @change="ecfDatabaseChange" />
					<label class="radio-button-database-label" for="oekobaudat">
						<p class="database-text">ÖKOBAUDAT</p>
					</label>
				</div>
			</div>
		</div>

		<!-- Buttons -->
		<!-- ------------------------------------------------------------------------------------------------------------- -->
		<div id="buttons" v-if="rotate">
			<button class="input-button" @click="$emit('calculateClicked')">Calculate</button>

			<button class="input-button" @click="$emit('clearValuesClicked')">Clear Values</button>
		</div>
	</div>
</template>

<script>
//Import Components,

import gsap from "gsap";

export default {
	components: {},
	emits: ["updateMaterial", "updateBuildingHeight", "updateLiveLoadValue", "updateDeadLoadValue", "updateFloorHeight", "updateXSpanValue", "updateYSpanValue", "updateBeamDistValue", "updateStructuralSystem", "calculateClicked", "clearValuesClicked", "collapseInputBarClicked"],
	data() {
		return {
			showInput: true,
			rotate: false,
			material: "",
			buildingHeightValue: 5.0,
			floorHeightValue: 4.0,
			xSpanValue: 6.9,
			ySpanValue: 6.9,
			structuralSystem: "",
			plateSystem: "Plate",
			beamSystem: "Beam",
			ecfDatabase: "",
			liveLoadValue: 2.0,
			deadLoadValue: 1.5,
			beamDistValue: 1.0,
		};
	},
	methods: {
		ecfDatabaseChange() {
			console.log("ecfDatabaseChanged");

			// console.log(this.ecfDatabase);

			// console.log('carbon before');
			// console.log(this.$store.state.databaseMaterial);

			if (this.ecfDatabase == "ICE") {
				this.$store.state.databaseMaterial.concrete.carbon = 342;
				this.$store.state.databaseMaterial.reinforcementBars.carbon = 1.99;
				this.$store.state.databaseMaterial.steel.carbon = 1.55;
				this.$store.state.databaseMaterial.profileSteelSheet.carbon = 2.76;
				this.$store.state.databaseMaterial.timberCLT.carbon = 206.96;
				this.$store.state.databaseMaterial.timberGLh.carbon = 225.28;
			} else {
				this.$store.state.databaseMaterial.concrete.carbon = 280;
				this.$store.state.databaseMaterial.reinforcementBars.carbon = 0.68;
				this.$store.state.databaseMaterial.steel.carbon = 1.125;
				this.$store.state.databaseMaterial.profileSteelSheet.carbon = 2.67;
				this.$store.state.databaseMaterial.timberCLT.carbon = 134.5;
				this.$store.state.databaseMaterial.timberGLh.carbon = 153.1;
			}

			// console.log('carbon after');
			// console.log(this.$store.state.databaseMaterial);
		},
		updateStructuralSystem: function (value) {
			// console.log('structuralSystem');
			// console.log(this.structuralSystem);

			if (this.material == "Steel") {
				this.plateSystem = "Holorib Slab";
				this.beamSystem = "Composite Beams";
				document.getElementById("slider-xSpan").max = 12;
				document.getElementById("slider-ySpan").max = 12;
				document.getElementById("slider-dead-load").max = 3;
			} else if (this.material == "Concrete") {
				this.plateSystem = "Flat Slab";
				this.beamSystem = "T-Beams";
				document.getElementById("slider-xSpan").max = 9; //actually 8m
				document.getElementById("slider-ySpan").max = 9; //actually 8m
				document.getElementById("slider-dead-load").max = 3;
			} else if (this.material == "Timber") {
				this.plateSystem = "CLT Slab on Glulam";
				this.beamSystem = "Ribbed Slab";
				if (this.structuralSystem == "Plate") {
					document.getElementById("slider-xSpan").max = 7;
					document.getElementById("slider-ySpan").max = 7;
					document.getElementById("slider-dead-load").max = 3;
				} else {
					document.getElementById("slider-xSpan").max = 10;
					document.getElementById("slider-ySpan").max = 10;
					document.getElementById("slider-dead-load").max = 3;
				}
			} else if (this.material == "Hybrid") {
				this.plateSystem = "HBV Slab";
				this.beamSystem = "CLT on Steel";
				if (this.structuralSystem == "Plate") {
					document.getElementById("slider-xSpan").max = 12;
					document.getElementById("slider-ySpan").max = 12;
					document.getElementById("slider-dead-load").max = 1.75;
				} else {
					document.getElementById("slider-xSpan").max = 7;
					document.getElementById("slider-ySpan").max = 7;
					document.getElementById("slider-dead-load").max = 3;
				}
			}
		},
	},
	watch: {
		material: "updateStructuralSystem",
		structuralSystem: "updateStructuralSystem",
		rotate: {
			handler() {
				var arrow = document.getElementById("arrow-input");
				var verticalText = document.getElementById("vertical-text-input");

				if (this.rotate) {
					gsap.to(arrow, { duration: 0.4, rotate: 180, transformOrigin: "center" });
				}

				if (!this.rotate) {
					gsap.to(arrow, { duration: 0.4, rotate: 0, transformOrigin: "center" });
				}
			},
		},
	},
	computed: {
		formattedBuildingHeightValue: {
			get() {
				return this.buildingHeightValue.toFixed(1);
			},
			set(value) {
				this.buildingHeightValue = +value;
			},
		},
		formattedFloorHeightValue: {
			get() {
				return this.floorHeightValue.toFixed(1);
			},
			set(value) {
				this.floorHeightValue = +value;
			},
		},
		formattedXSpanValue: {
			get() {
				return this.xSpanValue.toFixed(1);
			},
			set(value) {
				this.xSpanValue = +value;
			},
		},
		formattedYSpanValue: {
			get() {
				return this.ySpanValue.toFixed(1);
			},
			set(value) {
				this.ySpanValue = +value;
			},
		},
		formattedLiveLoadValue: {
			get() {
				return this.liveLoadValue.toFixed(2);
			},
			set(value) {
				this.liveLoadValue = +value;
			},
		},
		formattedDeadLoadValue: {
			get() {
				return this.deadLoadValue.toFixed(2);
			},
			set(value) {
				this.deadLoadValue = +value;
			},
		},
		formattedBeamDistValue: {
			get() {
				return this.beamDistValue.toFixed(1);
			},
			set(value) {
				this.beamDistValue = +value;
			},
		},
	},
};
</script>

<style scoped>
#bar {
	/* border: 1px solid black; */
	width: 18vw;
	min-width: 300px;
	height: 84vh;
	border-radius: 20px 20px 20px 20px;
	/* font-family: Roboto; */
	font-family: "Roboto", sans-serif;
	/* background: white; */
	background: transparent;
	backdrop-filter: blur(5px);
	/* box-shadow: 4px 4px 10px -5px rgba(0, 0, 0, 0.6); */
}

#title-placeholder {
	height: 7%;
}

#title-container {
	position: absolute;
	z-index: 100;
	/* border: 1px solid black; */
	height: 7%;
	width: 16vw;
	/* width: 10%; */
	margin: 0;
	/* background: black; */
	background: transparent;
	/* border-radius: 20px 20px 0px 0px; */
	display: flex;
	/* justify-content: space-between; */
	line-height: 100%;
}

#title {
	/* border: 1px solid rgba(255, 255, 255, 1); */
	font-family: "Lato", sans-serif;
	/* color: white;	 */
	color: rgba(0, 0, 0, 1);
	font-size: 1.45rem;
	/* width: 100%; */
	padding: 6% 6%;
	cursor: pointer;
}

.checkbox-collapse {
	display: none;
}

.lbl-checkbox-collapse {
	/* border: 1px solid rgba(255, 255, 255, 1); */
	border-radius: 50%;
	width: 50px;
	height: 37px;
	margin-top: 3.5%;
	padding: 0% 0%;
	cursor: pointer;
	color: black;
}

#arrow-input {
	font-size: 0.8rem;
	margin-left: 0.3rem;
	margin-top: 0.8rem;
}

/* -----------------------------------------------------------------------------------------------------
Separating Line
------------------------------------------------------------------------------------------------------- */

.separate-line {
	width: 85%;
	color: rgba(0, 0, 0, 0.7);
	border-top: 1px solid rgba(0, 0, 0, 0.2);
	margin: 0.4rem 1.6rem;
	/* border-radius: 2px; */
}

/* -----------------------------------------------------------------------------------------------------
Boxes
------------------------------------------------------------------------------------------------------- */

#material {
	/* border: 1px solid black; */
	height: 26%;
	margin: 0;
	/* padding: 2% 5%; */
	padding: 0% 4%;
}

#geometry {
	/* border: 1px solid black; */
	height: 18%;
	margin: 0;
	/* padding: 2% 5%; */
	padding: 0% 4%;
}

#structural {
	/* border: 1px solid black; */
	height: 20%;
	margin: 0;
	/* padding: 2% 5%;	 */
	padding: 0% 4%;
}

#carbon {
	/* border: 1px solid black; */
	height: 10%;
	margin: 0;
	/* padding: 2% 5%;	 */
	padding: 0% 4%;
}

#buttons {
	/* border: 1px solid black; */
	height: 12%;
	margin: 0;
}

.box {
	/* border: 1px solid rgba(0, 0, 0, 0.3); */
	height: 98%;
	border-radius: 10px;
}

.box-title {
	margin: 3%;
	font-size: 0.7rem;
	/* font-size: 12px; */
	font-weight: 600;
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.9);
}

.input-field {
	height: 10%;
	/* border: 1px solid black; */
	margin: 0px 3%;
	color: rgba(63, 63, 63, 1);
	font-size: 0.65rem;
	font-weight: 400;
	margin-bottom: 5%;
	text-transform: uppercase;
	display: flex;
	align-items: center;
	letter-spacing: 0.0425rem;
	letter-spacing: 0rem;
}

.input-text {
	width: 50%;
	/* border: 1px solid black; */
}

/* -----------------------------------------------------------------------------------------------------
Material
------------------------------------------------------------------------------------------------------- */

#material-form {
	/* border: 1px solid black; */
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-row-gap: 0;
	grid-column-gap: 6%;
	height: 80%;
	width: 80%;
	margin-left: 10%;
}

.hidebox {
	display: none;
}

.lbl-radio {
	text-align: center;
	box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3);
	padding: 10px;
	border: 1px solid #fff;
	transition: all 0.05s ease-in;
	border-radius: 10px;
	cursor: pointer;
	height: 50%;
	font-size: 0.6rem;
	color: rgba(0, 0, 0, 0.6);
}

.icon {
	height: 1.8rem;
}

/* ------------------------------------------------------------------------------------------------------
Slider
------------------------------------------------------------------------------------------------------- */

.range-slider {
	position: relative;
	-webkit-appearance: none;
	/* left: 10%; */
	height: 1px;
	border-radius: 5px;
	background: #7d7d7d;
	width: 24%;
	margin-left: 0%;
	margin-right: 6%;
}

.range-slider::-webkit-slider-thumb {
	-webkit-appearance: none; /* Override default look */
	appearance: none;
	width: 10px; /* Set a specific slider handle width */
	height: 10px; /* Slider handle height */
	border-radius: 5px;
	border: 1px solid black;
	background: #fff; /* Green background */
	cursor: pointer; /* Cursor on hover */
	transition: all 0.1s ease-in;
}

.range-slider::-webkit-slider-thumb:hover {
	transform: scale(1.3);
}

.slider-value {
	border: 1px solid black;
	width: 65px;
	color: #303030;
}

.range-input {
	width: 1.6rem;
	-webkit-appearance: none;
	appearance: none;
	/* border: 1px solid black; */
	border: none;
	outline: none;
	font-family: "Roboto", sans-serif;
	/* color: rgba(130, 130, 130, 1); */
	color: rgba(63, 63, 63, 0.9);
	font-size: 0.65rem;
	font-weight: 400;
	margin-right: 0.4rem;
	border-radius: 0.2rem;
	background-color: rgba(0, 0, 0, 0.05);
}

.range-input:focus {
	border: transparent;
	border: 1px solid rgba(0, 0, 0, 0.7);
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 5px;
	/* background: rgba(153, 29, 29, 0.3); */
}

.unit {
	/* border: 1px solid black; */
	width: 2.1rem;
}

/* -----------------------------------------------------------------------------------------------------
Structural system
------------------------------------------------------------------------------------------------------- */
.radio-button-system {
	-webkit-appearance: none;
	display: table-cell;
	vertical-align: middle;
}

.radio-button-system-label {
	width: 27%;
	/* border: 1px solid black; */
	border: 1px solid rgba(255, 255, 255, 0.7);
	border-radius: 5px;
	height: 200%;
	display: flex;
	align-content: center;
	margin-right: 0%;
	cursor: pointer;
	text-align: center;
	align-content: center;
	font-size: 0.52rem;
	display: block;
	box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3);
	padding: 0;
}

.radio-button-system-label:last-child {
	margin-right: 0%;
}

.system-text {
	/* line-height: 180%; */
}

/* -----------------------------------------------------------------------------------------------------
ECF Database
------------------------------------------------------------------------------------------------------- */
.radio-button-database {
	-webkit-appearance: none;
	display: table-cell;
	vertical-align: middle;
}

.radio-button-database-label {
	width: 27%;
	/* border: 1px solid black; */
	border: 1px solid rgba(255, 255, 255, 0.7);
	border-radius: 5px;
	/* height: 200%; */
	display: flex;
	align-content: center;
	margin-right: 0%;
	cursor: pointer;
	text-align: center;
	align-content: center;
	font-size: 0.52rem;
	display: block;
	box-shadow: 0px 4px 12px -4px rgba(0, 0, 0, 0.3);
	padding: 0;
}

.radio-button-database-label:last-child {
	margin-right: 0%;
}

.database-text {
	/* line-height: 180%; */
}

/* -----------------------------------------------------------------------------------------------------
Buttons
 ------------------------------------------------------------------------------------------------------- */

/* .input-button {
	width: 35%;
	height: 2.6rem;
	padding: .7rem;
	border-radius: 30px;
	border: 1px solid black;
	background: transparent;
	margin-top: 9%;
	margin-left: 10%;
	cursor: pointer;
	font-weight: 100;
	color: rgba(0, 0, 0, 0.8);
	box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.6);
	font-size: .75rem;
} */

.input-button {
	/* width: 26%; */
	width: 35%;
	height: 2.2rem;
	/* padding: .7rem; */
	border-radius: 0.4rem;
	border: 2px solid rgb(201, 201, 201);
	/* border: 1px solid transparent; */
	background: transparent;
	margin-top: 1.6%;
	margin-left: 10%;
	margin-right: 0%;
	font-weight: 700;
	font-size: 0.75rem;
	color: rgba(0, 0, 0, 0.8);
	/* color: rgba(255, 255, 255, 1); */
	background: rgba(255, 255, 255, 0.6);
	/* background: rgba(84, 107, 249, .9); */
	box-shadow: 1px 2px 8px -1px rgba(0, 0, 0, 0.2);
	cursor: pointer;
}

#vertical-text-input {
	position: fixed;
	top: 20%;
	left: 0.5%;
	color: rgba(0, 0, 0, 0.5);
	font-size: 1.8rem;
	font-weight: 400;
	line-height: 100%;
	/* border: 1px solid black; */
	writing-mode: vertical-rl;
	/* text-orientation: upright; */
	letter-spacing: 0.2rem;
	text-transform: uppercase;
}

/* ------------------------------------------------
Effects
 -------------------------------------------------- */
/* Material */
input[type="radio"]:hover + .lbl-radio {
	border-color: rgba(0, 0, 0, 0.1);
}

input[type="radio"]:checked + .lbl-radio {
	border-color: #5e5e5e;
}

input[type="radio"]:active + .lbl-radio {
	transform: translateY(4px);
	background: rgba(235, 235, 235, 0.2);
}

/* System */
.radio-button-system:hover + label {
	border-color: rgba(0, 0, 0, 0.3);
}

.radio-button-system:active + label {
	background: rgba(235, 235, 235, 0.2);
	transform: translateY(1px);
}

.radio-button-system:checked + label {
	border: 1px solid #303030;
	background-color: transparent;
	color: #303030;
}

/* System */
.radio-button-database:hover + label {
	border-color: rgba(0, 0, 0, 0.3);
}

.radio-button-database:active + label {
	background: rgba(235, 235, 235, 0.2);
	transform: translateY(1px);
}

.radio-button-database:checked + label {
	border: 1px solid #303030;
	background-color: transparent;
	color: #303030;
}

/* Buttons */
.input-button:hover {
	-webkit-transform: scale(1.01);
	transform: scale(1.01);
}

.input-button:active {
	background: rgba(235, 235, 235, 0.2);
	transform: translateY(1px);
}
</style>
